<script lang="ts" setup>
  const props = defineProps<{
    modelValue: number
    totalPages: number | undefined | null
  }>()
  const emits = defineEmits<{
    (e: 'update:modelValue', page: number): void
  }>()

  const page = computed({
    get() {
      return props.modelValue
    },
    set(newVal) {
      emits('update:modelValue', newVal)
    },
  })
</script>

<template>
  <QPagination
    v-if="totalPages"
    v-model="page"
    color="purple"
    :max="totalPages"
    :max-pages="6"
    boundary-numbers
    class="page__pagination"
    direction-links
    active-design="unelevated"
    round
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>

<style lang="scss" scoped>
  .page__pagination {
    @include pagination;
  }
</style>
